import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=6cec0078&scoped=true&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./PopupMessage.vue?vue&type=style&index=0&id=6cec0078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec0078",
  null
  
)

export default component.exports